import config from '../../legacy/customer/base/default/configuration';
import { Configuration } from '../type/configuration';

export default config as Configuration;